import { Product } from '~/lib/data-contract/salesforce';

export const getProductPromotionType = (productItem: Product) => {
    const promotionType = productItem.c_promotionType?.type;
    return promotionType;
};
